export default "__VITE_ASSET__Bw0BiK0o__"